import universalLocalStorage from "../utils/lib/universalLocalStorage.js";

export default async function getUserId() {
  let data = await universalLocalStorage.getItem("karuna-userId");
  return data;
}
